module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/SanGabriels-log_BW-p-2000-92af30446053bfc30861845fb297fdae.jpg";